import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { UserAPI } from '../../../../shared/types/api';

/**
 * Hook to fetch all available events for regular users
 */
export function useEvents() {
  return useQuery({
    queryKey: ['events'],
    queryFn: async (): Promise<UserAPI.GetEventsResponse> => {
      return api.get('/user/events');
    },
  });
}

